import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/frontru/aquaart-group/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/home/frontru/aquaart-group/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/frontru/aquaart-group/src/components/entities/header/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ButtonLink"] */ "/home/frontru/aquaart-group/src/components/ui/button/index.tsx");
;
import(/* webpackMode: "eager" */ "/home/frontru/aquaart-group/src/views/brands/components/header/index.module.scss");
;
import(/* webpackMode: "eager" */ "/home/frontru/aquaart-group/src/components/ui/image-text-block/index.module.scss");
;
import(/* webpackMode: "eager" */ "/home/frontru/aquaart-group/src/views/brands/components/about/index.module.scss");
;
import(/* webpackMode: "eager" */ "/home/frontru/aquaart-group/src/views/brands/components/advantages/index.module.scss");
;
import(/* webpackMode: "eager" */ "/home/frontru/aquaart-group/src/components/ui/container/index.module.scss");
;
import(/* webpackMode: "eager" */ "/home/frontru/aquaart-group/src/views/brands/components/more/index.module.scss");
